import classNames from '@sindresorhus/class-names';
import {FooterProps} from '@ui-kit/src/Footer/Footer.types';
import {footerTestId} from '@ui-kit/src/Footer/footerTestId';
import {FC} from 'react';

import {LeftSideBlock} from '@ui-kit/src/Footer/components/LeftSideBlock';
import {Sections} from '@ui-kit/src/Footer/components/Sections';

import styles from './Footer.module.scss';

export const Footer: FC<FooterProps> = ({
  links,
  onLinkClick,
  leftSideContent,
  onSectionClick,
}) => {
  const lowLinks = links.length <= 3;

  return (
    <footer data-testid={footerTestId.footer} className={styles.wrapper}>
      <div
        className={classNames(styles.footer, {
          [styles.lowLinks]: lowLinks,
        })}
      >
        <LeftSideBlock leftSideContent={leftSideContent} lowLinks={lowLinks} />
        <Sections
          sections={links}
          onLinkClick={onLinkClick}
          onSectionClick={onSectionClick}
          isLowLinks={lowLinks}
        />
      </div>
    </footer>
  );
};
